import { GatewayObject, PluAnalyse } from '@greenkub-fronts/shared/interface';
import { ProjectGateway } from './project-gateway.interface';

const baseUrl = 'gk/projects';
export class HttpProjectGateway implements ProjectGateway {
  getProjectById(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  getProjectsByUser(args: {
    userId: string;
    page?: number;
    limit?: number;
    groupName?: string;
  }) {
    return {
      url: `${baseUrl}/${args.userId}/my-project`,
      method: 'GET',
      params: {
        page: args.page,
        limit: args.limit,
        groupName: args.groupName,
      },
    };
  }

  getProjectByCustomer(args: { userId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.userId}/customer-projects`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  getProjectByToken(args: { token: string; groupName: string }) {
    return {
      url: `${baseUrl}/token/${args.token}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  getOpportunityById(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/odoo-project`,
      method: 'GET',
    };
  }

  getPluAnalyseByProjectId(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/plu-analyse`,
      method: 'GET',
    };
  }

  patchPluAnalyse(args: { pluAnalyseId: string; pluAnalyse: PluAnalyse }) {
    return {
      url: `${baseUrl}/${args.pluAnalyseId}/plu-analyse`,
      method: 'PATCH',
      data: args.pluAnalyse,
    };
  }

  getMondayProjectById(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/monday-project`,
      method: 'GET',
    };
  }

  getPlanningByProjectId(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/planning`,
      method: 'GET',
    };
  }

  getTechnicalVisitByProjectId(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/technical-visit`,
      method: 'GET',
    };
  }

  getTransportByProjectId(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/transport`,
      method: 'GET',
    };
  }

  getProductionByProjectId(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/production`,
      method: 'GET',
    };
  }

  getSAVByProjectId(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/sav`,
      method: 'GET',
    };
  }

  getIncidentByProjectId(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/incident`,
      method: 'GET',
    };
  }

  getMondayLineByBoardIdAndItemId(args: { boardId: string; itemId: string }) {
    return {
      url: `${baseUrl}/board/${args.boardId}/item/${args.itemId}`,
      method: 'GET',
    };
  }

  searchProject(query: any) {
    return {
      url: `${baseUrl}/search`,
      method: 'GET',
      params: { search: query },
    };
  }

  getPluByProject(args: { projectId: string }) {
    return { url: `${baseUrl}/${args.projectId}/plu`, method: 'GET' };
  }

  triggerPostInMonday(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/trigger-create-all-in-monday`,
      method: 'POST',
    };
  }

  triggerPrefillKizeo(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/trigger-prefill-kizeo`,
      method: 'POST',
    };
  }

  triggerSyncSignWithOdoo(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/sync-signature`,
      method: 'PATCH',
    };
  }

  postCustomerR1New(args: { data: any }) {
    return {
      url: `${baseUrl}/customer-r1-new`,
      method: 'POST',
      data: args.data,
    };
  }

  triggerProject10Payment(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/trigger-project-ten-payment`,
      method: 'POST',
    };
  }

  triggerProjectFollowingInstructions(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/trigger-project-following-instruction`,
      method: 'POST',
    };
  }

  triggerProject50Payment(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/trigger-project-fifty-payment`,
      method: 'POST',
    };
  }

  syncWithOdoo(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/trigger-sync-odoo`,
      method: 'POST',
    };
  }

  syncWithMonday(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/trigger-sync-monday`,
      method: 'POST',
    };
  }

  patchProject(args: { projectId: string; project: any }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'PATCH',
      data: args.project,
    };
  }

  postLostRestart(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/lost-reload`,
      method: 'POST',
    };
  }

  patchNoShow(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/no-show`,
      method: 'PATCH',
    };
  }

  patchReport(args: { projectId: string; date: Date }) {
    return {
      url: `${baseUrl}/${args.projectId}/report`,
      method: 'PATCH',
      data: { date: args.date },
    };
  }

  patchNext(args: { projectId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.projectId}/next`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchCancel(args: { projectId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.projectId}/cancel`,
      method: 'PATCH',
      data: args.data,
    };
  }

  patchDelete(args: { projectId: string }) {
    return { url: `${baseUrl}/${args.projectId}`, method: 'DELETE' };
  }

  getPaginatedProject(args: {
    archiveName: string;
    page: number;
    limit: number;
    filterName: any;
    param: any;
    order: any;
    customerNameSearchValue: any;
    groupName: string;
    filterProjectType?: string;
    filterSales?: string;
    filterUrba?: string;
  }) {
    return {
      url: `${baseUrl}/paginated`,
      method: 'GET',
      params: {
        archiveName: args.archiveName,
        page: args.page,
        limit: args.limit,
        filterName: args.filterName,
        param: args.param,
        order: args.order,
        customerNameSearchValue: args.customerNameSearchValue,
        groupName: args.groupName,
        filterProjectType: args.filterProjectType || 'all',
        filterSales: args.filterSales || 'all',
        filterUrba: args.filterUrba || 'all',
      },
    };
  }

  getArchiveProjectByDateOf(args: {
    month: string;
    year: string;
    searchValue: string;
    attribute: string;
    groupName: string;
  }) {
    return {
      url: `${baseUrl}/archives/project-by-date`,
      method: 'GET',
      params: {
        month: args.month,
        year: args.year,
        searchValue: args.searchValue,
        attribute: args.attribute,
        groupName: args.groupName,
      },
    };
  }

  getArchiveProjectsCount(args: { filtre: any; param: any }) {
    return {
      url: `${baseUrl}/archives/project-count`,
      method: 'GET',
      params: { filtre: args.filtre, param: args.param },
    };
  }

  getArchiveBdc(args: {
    month: any;
    year: any;
    searchDate: Date;
    groupName: string;
  }) {
    return {
      url: `${baseUrl}/archives/bdc`,
      method: 'GET',
      params: {
        month: args.month,
        year: args.year,
        searchDate: args.searchDate,
        groupName: args.groupName,
      },
    };
  }

  getArchiveBdcCount(args: { year: any; searchDate: any }) {
    return {
      url: `${baseUrl}/archives/bdc-count`,
      method: 'GET',
      params: { year: args.year, searchDate: args.searchDate },
    };
  }

  getSortedClient(args: {
    limit: number;
    offset: number;
    order: string;
    letter: string;
    search: string;
    groupName: string;
  }) {
    return {
      url: `${baseUrl}/archives/sort-client`,
      method: 'GET',
      params: {
        limit: args.limit,
        offset: args.offset,
        order: args.order,
        letter: args.letter,
        search: args.search,
        groupName: args.groupName,
      },
    };
  }

  patchProjectConducteurTvx(args: {
    projectId: string;
    conducteurTvxId: string;
  }): GatewayObject {
    return {
      url: `${baseUrl}/patch-conducteur-tvx/${args.projectId}`,
      method: 'PATCH',
      data: {
        conducteurTvxId: args.conducteurTvxId,
      },
    };
  }
}
